import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { SubGrupo } from '../models/subGrupo';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/SubGrupos';

@Injectable({
  providedIn: 'root'
})
export class SubGrupoService {
   
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getSubGrupos(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetByGrupo?grupoId=' + code })
  }

  save(subGrupo: SubGrupo)
  {
    return this._http.post({ url: baseUrl + '/Save', body: subGrupo });
  }

  delete(id: number)
  {
    return this._http.get({ url: baseUrl + '/Delete?id=' + id});
  }
}
